import _taggedTemplateLiteral from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';
var superLargeTitleOnMobile = media.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 30px;\n  line-height: 1.27;\n"])));
var superLargeDescriptionOnMobile = media.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 1.78;\n"])));
export var TitleDescription = styled.div.withConfig({
  componentId: "yqcc6z-0"
})([""]);
var sizes = {
  'super-small': css(["h1,h2,h3,h4,h5,h6{font-size:14px;font-weight:700;line-height:20px;margin:0;}", "{font-size:14px;font-weight:400;line-height:28px;margin:4px 0 0;}"], TitleDescription),
  small: css(["h1,h2,h3,h4,h5,h6{font-size:16px;font-weight:600;line-height:1.5;margin:0;}", "{font-size:14px;font-weight:400;line-height:28px;margin:4px 0 0;}"], TitleDescription),
  medium: css(["h1,h2,h3,h4,h5,h6{font-size:24px;font-weight:700;line-height:1.5;margin:0;}", "{font-size:16px;font-weight:400;line-height:28px;margin:4px 0 0;}"], TitleDescription),
  'medium-thin': css(["h1,h2,h3,h4,h5,h6{font-size:24px;font-weight:400;line-height:1.5;margin:0;}", "{font-size:16px;font-weight:400;line-height:28px;margin:4px 0 0;}"], TitleDescription),
  'super-medium': css(["h1,h2,h3,h4,h5,h6{font-size:32px;font-weight:700;line-height:48px;margin:0;}", "{font-size:16px;font-weight:400;line-height:28px;}"], TitleDescription),
  large: css(["h1,h2,h3,h4,h5,h6{font-size:34px;font-weight:700;line-height:44px;margin:0;}", "{font-size:16px;font-weight:400;line-height:28px;}"], TitleDescription),
  'large-bold': css(["h1,h2,h3,h4,h5,h6{margin:0;font-weight:900;font-size:40px;line-height:50px;}", "{font-weight:normal;font-size:20px;line-height:50px;}"], TitleDescription),
  'super-large': css(["h1,h2,h3,h4,h5,h6{font-size:48px;font-weight:700;line-height:54px;margin:0 0 20px;", ";}", "{font-size:20px;font-weight:400;line-height:32px;", ";}"], superLargeTitleOnMobile, TitleDescription, superLargeDescriptionOnMobile),
  'extra-large': css(["h1,h2,h3,h4,h5,h6{font-size:44px;font-weight:700;line-height:1.08;margin:0 0 24px;", ";}", "{font-size:24px;font-weight:normal;line-height:1.5;margin-bottom:44px;", ";}"], superLargeTitleOnMobile, TitleDescription, superLargeDescriptionOnMobile)
};
var directions = {
  left: css([""]),
  center: css(["text-align:center;"]),
  right: css(["text-align:right;"])
};
var colors = {
  black: css(["h1,h2,h3,h4,h5,h6{color:", ";}", "{color:", ";}"], function (_ref) {
    var theme = _ref.theme;
    return theme.textColor;
  }, TitleDescription, function (_ref2) {
    var theme = _ref2.theme;
    return theme.textColor;
  }),
  'black-title-gray-description': css(["h1,h2,h3,h4,h5,h6{color:#292a2b;}", "{color:#919eaa;}"], TitleDescription),
  red: css(["h1,h2,h3,h4,h5,h6{color:var(--error);}", "{color:var(--error);}"], TitleDescription),
  green: css(["h1,h2,h3,h4,h5,h6{color:#4eda9d;}", "{color:#4eda9d;}"], TitleDescription),
  blue: css(["h1,h2,h3,h4,h5,h6{color:var(--blue_100);}", "{color:var(--blue_100);}"], TitleDescription),
  white: css(["h1,h2,h3,h4,h5,h6{color:#fff;}", "{color:#fff;}"], TitleDescription),
  yellow: css(["h1,h2,h3,h4,h5,h6{color:#fcbd26;}", "{color:#fcbd26;}"], TitleDescription)
};
var TitleBlockWrapper = styled.div.withConfig({
  componentId: "yqcc6z-1"
})(["width:100%;", ";", ";", ";"], function (_ref3) {
  var size = _ref3.size;
  return sizes[size || 'large'];
}, function (_ref4) {
  var color = _ref4.color;
  return colors[color || 'black'];
}, function (_ref5) {
  var direction = _ref5.direction;
  return directions[direction || 'left'];
});
export default TitleBlockWrapper;